import {React, useState, useEffect} from 'react';

import styles from './standings.module.css';
import constants from '../../../constants.js';
import api from '../../../routes/api.js';
import utils from '../../../utils/utils.js';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useApiProvider } from '../../../providers/ApiProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider.js';

import Table from "../../common/Table/Table.js";
import Select from "../../common/Select/Select.js";

const Standings = ({setSelectedMenuItem, selectedLocation, selectedDivision}) => {
  const { setIsSidebarShowing } = useSidebarProvider();
  const { setDialog, isLoading, setIsLoading, LoadingSpinner} = useApiProvider();
  const { leagueType } = useLeagueTypeProvider();

  const [fullStandingsList, setFullStandingsList] = useState([]);
  const [filteredStandingsList, setFilteredStandingsList] = useState([]);
  const [pods, setPods] = useState([]);
  const [podFilter, setPodFilter] = useState(constants.all);

  const onPodChange = (e) => {
    const newPodFilter = e.currentTarget.value;
    setPodFilter(newPodFilter);
    setFilteredStandingsList(filterTeams(newPodFilter));
  }

  const filterTeams = (pod) => {
    var newList = [];

    if (pod == constants.all){
      newList = fullStandingsList;
    } 
    else {
      const filteredList = fullStandingsList.filter((value) => {
        return value[constants.pod] == pod;
      })
      // sort data by pod ranking
      newList = filteredList.sort((a, b) => {
      if (a[constants.podRanking] < b[constants.podRanking]) return -1;
      if (a[constants.podRanking] > b[constants.podRanking]) return 1;
      return 0;
    });
    }

    return newList
  }

  const getTableCols = () => {
    let cols = [];
    switch (leagueType) {
      case constants.pages.localLeagues:
        cols = constants.table.clubCols;
        break;
      case constants.pages.genderLeagues:
        cols = constants.table.genderStandingsCols;
        break;
      case constants.pages.leagues:
        cols = podFilter == "All" ? constants.table.teamCols : constants.table.teamPodCols;
        break;
      default:
        cols = constants.table.teamCols;
    }
    return cols;
  }

  useEffect(() => {
    if (isLoading) return; // Wait for data from App.js
    
    const getStandings = async () => {
      setIsLoading(true);

      try {
        const baseUrl = utils.getBaseUrl(leagueType);

        const standingsResponse = await api.fetch(baseUrl, constants.uri.standings(selectedDivision[constants.divisionId]));
        if (standingsResponse.hasOwnProperty('errors')) throw standingsResponse;

        const standings = standingsResponse[constants.values].map(t => ({
          ...t,
          [constants.fullTeam]: (
            <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-start', alignItems:'center', gap:'10px'}}>
              <img src={`/logos/${t[constants.clubLogo]}.png`} style={{height:'32px', width: '32px'}}/>
              {t[constants.teamName]}
            </div>),
            [constants.overallRecord]: t[constants.wins] + "-" + t[constants.losses] + "-" + t[constants.draws]
        }));

        let pods = [
          ...new Map(
            standings.map(team => [team[constants.pod], { label: team[constants.pod], value: team[constants.pod], key: team[constants.pod].toLowerCase()}])
          ).values()
        ];
        // If there are no pods remove that option
        if (pods.length == 1 && pods[0].label == " ") {
          pods = [];
          pods.push({label: "All", value: "All", key: "all"});
        } else {
          pods.unshift({label: "All", value: "All", key: "all"});
        }

        standings.sort((a, b) => {
          if (a[constants.ranking] < b[constants.ranking]) {
            return -1;
          }
          if (a[constants.ranking] > b[constants.ranking]) {
            return 1;
          }
          return 0;
        });

        setPods(pods);
        setFullStandingsList(standings);
        setFilteredStandingsList(standings);
        setIsLoading(false);
      } 
      catch (err) {
        console.error(err);
        setDialog({
          title: err.title ? err.title : constants.messages.errorMessage, 
          code: err.code ? err.code : "N/A", 
          message: err.message, 
          isError: true});
        setIsLoading(false);
      }
    }
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem(constants.sidebarItems[2]);
    if (selectedDivision[constants.divisionId] != "") getStandings();
  },[selectedDivision])
  
  return (
    <div className={styles.Standings}>
      <div className={styles.Header}>
        <div className={styles.Title}>{constants.titles.teamStats}</div>
        <div className={styles.SubTitle}> {`${selectedLocation[constants.locationName]} ${selectedDivision[constants.divisionName]} DIVISION`}</div>

          {!isLoading ? <>
            <div style={{ visibility: leagueType===constants.pages.localLeagues ? 'hidden' : 'visible' }} className={styles.PodSelect}>
              <Select disabled={false} onChange={onPodChange} additionalStyle={styles.Select} currentValue={podFilter} options={pods}/>
            </div>
          </> : <></>}
          

      </div>

      {!isLoading ?
      <div className={styles.TableContainer}>
        <Table 
          headers={getTableCols()}
          defaultHeader={constants.ranking}
          tableKeys={[constants.teamId, constants.clubId]}
          tableData={filteredStandingsList}
          setTableData={setFilteredStandingsList}
          canSort={true}/>
      </div>
      : <LoadingSpinner/>}
    
    </div>
  )
}

export default Standings;